import React from 'react';
import { useMediaQuery } from 'react-responsive';
import config from './config';

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({
    maxWidth: config.mobile.maxWidth,
  });
  return isMobile ? children : null;
};

export default Mobile;
